import reporter from 'redux-reporter';

/**
 * @name DTM
 * @description Executes the provided DTM rule on call
 * @param {string} type Name of the direct call rule to be executed
 */
export const DTM = reporter( ({ type }) => {
    if( !window._satellite ) return console.warn( `DTM Reporter: Attempted to track "${ type }", but _satellite is unavailable.` );
    try {
        window._satellite.track( type );
    } catch (err) {
        console.error( `Adobe DTM Event failed: ${ type }`, err );
    }
});